import { createElement as h } from 'react';
import { useRoute } from './useRoute';
/**
 * Компонент пути
 */
export const Route = ({ render, path, match, component, children, strict, exact, }) => {
    const useRouteMatch = useRoute(path, strict, exact);
    const [matches, params] = match || useRouteMatch;
    if (!matches) {
        return null;
    }
    if (render) {
        return render({ params, path });
    }
    if (component) {
        return h(component, { params, path });
    }
    // support render prop or plain children
    return typeof children === 'function' ? children(params) : children;
};
